import { makeObservable, observable } from "mobx";
import { DataType, IContent } from "types";
import { Data } from ".";

export abstract class Content<I extends IContent> extends Data<I> implements IContent {
  created_by: number = null;
  updated_by: number = null;
  constructor(type: DataType, data: I) {
    // The super constructr takes care of references to the service, validation rules
    // and intialized the base members with mobx decorators
    super(type, data);

    // Since Mobx cannot track derived class objects automatically,
    // the decorators have to be provided manually
    makeObservable(this, {
      created_by: observable,
      updated_by: observable,
    });

    // Initialize data
    // While the super constructor will call this once,
    // the default values given to members will overwrite this so it has to be called again here.
    this.fromData(data);
  }

  /*******************************************************************************************************************************************
   * Database Access
   ********************************************************************************************************************************************/

  /*******************************************************************************************************************************************
   * Overwrites
   ********************************************************************************************************************************************/

  protected fromData(data: I): void {
    super.fromData(data);
    this.created_by     = data.created_by && Number(data.created_by);
    this.updated_by     = data.updated_by && Number(data.updated_by);
  }

  public toData(): any {
    return {
      ...super.toData(),
      created_by: this.created_by || null,
      updated_by: this.updated_by || null,
    };
  }

  public toPatchData(patch: Partial<I>): any {
    return {
      ...super.toPatchData(patch),
      created_by: "created_by" in patch ? this.created_by: undefined,
      updated_by: "updated_by" in patch ? this.updated_by: undefined,
    };
  }

  /*******************************************************************************************************************************************
   * Getter
   ********************************************************************************************************************************************/

  /*******************************************************************************************************************************************
   * Setter
   ********************************************************************************************************************************************/

  /*******************************************************************************************************************************************
   * Actions
   ********************************************************************************************************************************************/
}
